<router-outlet></router-outlet>
<ng-template toastHost></ng-template>
<ng-template spinnerHost></ng-template>
<app-modal *ngIf="isModalOpen" [modalData]="modalData"></app-modal>
